enum BalanceProviderType {
  INTERNAL = 'Internal',
  EXTERNAL = 'External',
}

export default BalanceProviderType;
